import { html, LitElement, PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class GzInputErrorWebComponent extends LitElement {
  private error: string | null = null;
  // need to keep the last shown error in the html for fading out the error
  private lastShownError: string | null = null;

  @property({ attribute: true, reflect: true })
  inputWidth;

  public set Error(error: string | null) {
    if (this.error === error) {
      return;
    }

    const previous = this.error;

    this.error = error;

    if (error) {
      this.lastShownError = error;
    }

    this.requestUpdate('error', previous);
  }

  protected updated(_changedProperties: PropertyValues) {
    super.updated(_changedProperties);

    if(_changedProperties.has('inputWidth')) {
      this.style.width = this.returnInputWidth();
      this.style.maxWidth = this.returnInputWidth();
    }
  }

  public static get styles() {
    return styles;
  }

  private returnInputWidth(): string {
    if (this.inputWidth === 'full') {
      return '100%';
    } else {
      return this.inputWidth + 'px';
    }
  }

  render() {
    // &nbsp; is there in order to prevent the p tag from being at 0px height when it's empty
    return html`
      <div class="input-error-wrapper ${this.error ? 'visible' : ''}">
        <p part="error-label">${this.lastShownError ? this.lastShownError : '&nbsp;'}</p>
      </div>
    `;
  }
}
